import * as Yup from 'yup'

const Validation = Yup.object().shape({
  body: Yup.string()
    .min(1, 'Comment is required.')
    .required('Comment is required.'),
})

export default Validation
